import { routes } from "@/constants/routes"

export type NavItemId =
  | "casino"
  | "sports"
  | "tournaments"
  | "promotions"
  | "vip"

export type NavItemDef = {
  href: string
  comingSoon?: boolean
}

export const NAV_ITEMS: Record<NavItemId, NavItemDef> = {
  casino: { href: routes.CASINO },
  sports: { href: routes.SPORTS },
  tournaments: { href: routes.TOURNAMENTS, comingSoon: true },
  promotions: { href: routes.PROMOTIONS, comingSoon: true },
  vip: { href: routes.VIP, comingSoon: true }
}

export const HEADER_NAV_ORDER = [
  "casino",
  "sports",
  "tournaments",
  "promotions",
  "vip"
] as const satisfies readonly NavItemId[]

export const SIDEBAR_NAV_ORDER = [
  "sports",
  "casino",
  "vip",
  "promotions",
  "tournaments"
] as const satisfies readonly NavItemId[]

export function isNavItemActive(pathname: string, href: string) {
  if (href === "/") return pathname === "/"
  return pathname === href || pathname.startsWith(`${href}/`)
}
